import { refreshGitHubTokenIfNeeded } from "../github_login";

export function goGistEditorHome(): void {
  // console.log("goToHome");
  location.href = "./";
}

// will trigger edit.html / edit.js
export function goToGistById(id: string): void {
  const uri = "./edit?gistid=" + id;
  location.href = uri;
}

// will trigger edit.html / edit.js
export function goToCreateNewGist(lang: string): void {
  const uri = "./edit?new=" + encodeURIComponent(lang);
  location.href = uri;
}

// will trigger nogist.html / NoGist.svelte
export function goToNoGist(gistid: string): void {
  const uri = "./nogist?id=" + encodeURIComponent(gistid);
  location.href = uri;
}

refreshGitHubTokenIfNeeded();
